<ng-container *ngIf="screenWidth > 475">
    <section class="main-section" *ngIf="data.data?.creationType == null || data.data?.creationType == 'SCHEDULE'">
        <app-dialog-header [title]="'Book Visit'" (close)="cancel()"></app-dialog-header>
        <div class="input-field-section">
            <div class="input-box-full">
                <div class="input-label">Title <span class="required">*</span></div>
                <input class="custom-input" placeholder="Enter subject" [(ngModel)]="meetDetails.title">
            </div>

            <div class="two-col-row">
                <div class="input-box">
                    <div class="input-label">Visit Type</div>
                    <div class="radio-pill-row">
                        <div class="radio-pill" [class.selected]="meetDetails.meetingType === 'PHYSICAL'" (click)="setMeetingType('PHYSICAL')">
                            <span class="radio-dot"></span>In Person
                        </div>
                        <div class="radio-pill" [class.selected]="meetDetails.meetingType === 'VIRTUAL'" (click)="setMeetingType('VIRTUAL')">
                            <span class="radio-dot"></span>Virtual / Demo
                        </div>
                    </div>
                </div>

                <div class="input-box" *ngIf="meetDetails.meetingType === 'PHYSICAL'">
                    <div class="input-label">Location Type</div>
                    <div class="radio-pill-row">
                        <div class="radio-pill" [class.selected]="meetDetails.locationType === 'CLIENT_LOCATION'" (click)="setLocationType('CLIENT_LOCATION')">
                            <span class="radio-dot"></span>Client Location
                        </div>
                        <div class="radio-pill" [class.selected]="meetDetails.locationType === 'BUSINESS_LOCATION'" (click)="setLocationType('BUSINESS_LOCATION')">
                            <span class="radio-dot"></span>Activity
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box-full" *ngIf="meetDetails.meetingType === 'VIRTUAL'">
                <div class="input-label">Meeting Provider <span class="required">*</span></div>
                <div class="radio-pill-row">
                    <div class="radio-pill" [class.selected]="meetDetails.meetingLinkMode === 'GOOGLE_MEET'"
                        [class.disabled]="!googleIntegrationStatus?.googleMeetAvailable"
                        (click)="setMeetingLinkMode('GOOGLE_MEET')">
                        <span class="radio-dot"></span>Google Meet
                    </div>
                    <div class="radio-pill" [class.selected]="meetDetails.meetingLinkMode === 'MANUAL'"
                        (click)="setMeetingLinkMode('MANUAL')">
                        <span class="radio-dot"></span>Manual Link
                    </div>
                    <div class="radio-pill disabled">
                        <span class="status-tag coming-soon-tag">Coming soon</span>Zoom
                    </div>
                </div>

                <div class="hint-text" *ngIf="meetDetails.meetingLinkMode === 'GOOGLE_MEET' && googleIntegrationStatus?.reconnectRequired">
                    Google needs to be reconnected before a Google Meet link can be created. Reconnect from Settings &gt; Channels &gt; Meeting Integrations.
                </div>

                <div class="d-flex align-items-center gap-2 mt-2" *ngIf="meetDetails.meetingLinkMode === 'GOOGLE_MEET' && googleIntegrationStatus?.meetRecordingAvailable">
                    <input type="checkbox" [(ngModel)]="meetDetails.automaticRecordingEnabled">
                    <span>Automatically record this meeting</span>
                </div>

                <div class="lead-section" style="align-items:center" *ngIf="meetDetails.meetingLinkMode === 'MANUAL'">
                    <input class="custom-input" [(ngModel)]="meetDetails.meetingLink" placeholder="Enter link">
                    <div class="clipboard d-flex cursor-pointer" (click)="clipboardCopy(meetDetails.meetingLink)" *ngIf="!clipboard">
                        <mat-icon style="font-size:18px">file_copy</mat-icon>
                    </div>
                    <div class="clipboard" *ngIf="clipboard">
                        <img src="./../../../assets/images/common/copied_link.svg" alt="" style="width:15px" />
                    </div>
                </div>
            </div>

            <div class="input-box"
                *ngIf="meetDetails.locationType === 'CLIENT_LOCATION' && meetDetails.meetingType === 'PHYSICAL'">
                <div class="input-label">Meeting Location</div>
                <div class="field-dd" [class.open]="openDropdown === 'meetingLocation'">
                    <input type="text" placeholder="Search for location" class="custom-input"
                        [(ngModel)]="meetDetails.meetingLocated" (ngModelChange)="search()"
                        (focus)="openMeetingLocationDropdown()">
                    <div class="field-dd-panel" *ngIf="openDropdown === 'meetingLocation' && locations.length">
                        <div class="field-dd-row" *ngFor="let option of locations"
                            (mousedown)="selectMeetingLocation(option); $event.preventDefault()">
                            {{ option.displayName }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box"
                *ngIf="meetDetails.locationType == 'BUSINESS_LOCATION' && meetDetails.meetingType == 'PHYSICAL' && storeList.length > 1">
                <div class="input-label">Select Store</div>
                <div class="field-dd" [class.open]="openDropdown === 'store'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('store')">
                        <span>{{ getStoreLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'store'">
                        <div class="field-dd-row" *ngFor="let item of storeList"
                            [class.selected]="meetDetails.storeId === item.id" (click)="selectStore(item)">
                            {{ item.storeName }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="two-col-row">
                <div class="input-box">
                    <div class="start-time">
                        <div class="input-label">Start Date & Time <span class="required">*</span></div>
                        <div class="checkbox d-flex align-items-center gap-1">
                            <span class="input-label" style="margin-bottom:0">All day</span>
                            <input type="checkbox" [(ngModel)]="allDayCheckbox" (change)="setStartTime()">
                        </div>
                    </div>
                    <div class="two-col-row">
                        <div class="field-dd" [class.open]="openDropdown === 'startDate'">
                            <button type="button" class="field-dd-trigger" (click)="openStartDatePicker()">
                                <span>{{ getStartDateLabel() }}</span>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                            </button>
                            <app-custom-calendar *ngIf="openDropdown === 'startDate'" mode="single" [showTime]="false"
                                align="left" [selectedDate]="startDateAsDate" (dateChange)="onStartDateApplied($event)"
                                (cancel)="closeDropdowns()">
                            </app-custom-calendar>
                        </div>
                        <div class="field-dd" [class.open]="openDropdown === 'startTime'" [class.disabled]="allDayCheckbox">
                            <button type="button" class="field-dd-trigger" [disabled]="allDayCheckbox"
                                (click)="toggleDropdown('startTime')">
                                <span>{{ callStartTime || 'HH : MM' }}</span>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                            </button>
                            <div class="field-dd-panel" *ngIf="openDropdown === 'startTime'">
                                <ng-container *ngFor="let item of filteredStartTimeArray">
                                    <div class="field-dd-row" *ngIf="!item.isDisabled"
                                        [class.selected]="callStartTime === item.viewValue"
                                        (click)="selectStartTime(item)">
                                        {{ item.viewValue }}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input-box justify-content-end">
                    <div class="input-label">End Date & Time</div>
                    <div class="two-col-row">
                        <div class="field-dd" [class.open]="openDropdown === 'endDate'" [class.disabled]="allDayCheckbox">
                            <button type="button" class="field-dd-trigger" [disabled]="allDayCheckbox" (click)="openEndDatePicker()">
                                <span>{{ getEndDateLabel() }}</span>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                            </button>
                            <app-custom-calendar *ngIf="openDropdown === 'endDate'" mode="single" [showTime]="false"
                                align="right" [selectedDate]="endDateAsDate" [minDate]="minEndDateAsDate"
                                (dateChange)="onEndDateApplied($event)" (cancel)="closeDropdowns()">
                            </app-custom-calendar>
                        </div>
                        <div class="field-dd" [class.open]="openDropdown === 'endTime'" [class.disabled]="allDayCheckbox">
                            <button type="button" class="field-dd-trigger" [disabled]="allDayCheckbox"
                                (click)="toggleDropdown('endTime')">
                                <span>{{ callEndTime || 'HH : MM' }}</span>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                            </button>
                            <div class="field-dd-panel" *ngIf="openDropdown === 'endTime'">
                                <ng-container *ngFor="let item of filteredEndTimeArray">
                                    <div class="field-dd-row" *ngIf="!item.isDisabled"
                                        [class.selected]="callEndTime === item.viewValue"
                                        (click)="selectEndTime(item)">
                                        {{ item.viewValue }}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box">
                <div class="input-label">Status</div>
                <div class="field-dd" [class.open]="openDropdown === 'status'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('status')">
                        <span>{{ getStatusLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'status'">
                        <div class="field-dd-row" *ngFor="let item of status; trackBy: trackByOptionValue"
                            [class.selected]="meetDetails.meetingStatus === item.value" (click)="selectStatus(item.value)">
                            {{ item.viewValue }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box">
                <div class="input-label">Reminder</div>
                <div class="field-dd" [class.open]="openDropdown === 'reminder'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('reminder')">
                        <span>{{ getReminderLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'reminder'">
                        <div class="field-dd-row" *ngFor="let item of reminder; trackBy: trackByOptionValue"
                            [class.selected]="meetDetails.remainder === item.value" (click)="selectReminder(item.value)">
                            {{ item.viewValue }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box" *ngIf="data.data.type == 'ALL_MEETINGS'">
                <div class="input-label">Select <span class="required">*</span></div>
                <div class="lead-section">
                    <div class="field-dd type-dd" [class.open]="openDropdown === 'participantType'">
                        <button type="button" class="field-dd-trigger" (click)="toggleDropdown('participantType')">
                            <span>{{ getParticipantTypeLabel() }}</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                        </button>
                        <div class="field-dd-panel" *ngIf="openDropdown === 'participantType'">
                            <div class="field-dd-row" *ngFor="let item of type; trackBy: trackByOptionValue"
                                [class.selected]="participantType === item.value" (click)="selectParticipantType(item.value)">
                                {{ item.viewValue }}
                            </div>
                        </div>
                    </div>
                    <div class="field-dd contact-dd">
                        <input type="text" placeholder="Search by name" class="custom-input" [(ngModel)]="selectedContact"
                            [formControl]="myControl" (focus)="openContactDropdown()">
                        <div class="field-dd-panel" *ngIf="openDropdown === 'contact'">
                            <div class="field-dd-row" *ngFor="let option of filteredOptions | async"
                                (mousedown)="contactSelected(option); closeDropdowns(); $event.preventDefault()">
                                {{ option.personalInfo.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box" *ngIf="leadIdPipelineId && isStaffAdmin">
                <div class="input-label">Assign To</div>
                <div class="field-dd" [class.open]="openDropdown === 'assignedTo'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('assignedTo')">
                        <span>{{ meetDetails.assignedName || 'Select Staff' }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'assignedTo'">
                        <input type="text" class="field-dd-search" placeholder="Search staff" [(ngModel)]="staffSearch"
                            (ngModelChange)="filterStaff()" autocomplete="off">
                        <div class="field-dd-row" *ngFor="let staff of pipelineBasedStaff.get(leadIdPipelineId)?.filteredStaff"
                            [class.selected]="meetDetails.assignedTo === staff.id" (click)="selectAssignedTo(staff)">
                            {{ staff.name }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box-full">
                <div class="input-label">Participants</div>
                <div class="chip-add-trigger" (click)="addParticipants()">+ Add</div>
                <div class="chip-list">
                    <ng-container *ngFor="let items of meetDetails.participantsList; let i = index">
                        <div class="chip-item">
                            {{ items.leadName }}
                            <span class="chip-item-close" (click)="closeparticipant(i, true)">&#10005;</span>
                        </div>
                    </ng-container>
                    <ng-container *ngFor="let email of meetDetails.emailData; let i = index">
                        <div class="chip-item">
                            {{ email }}
                            <span class="chip-item-close" (click)="closeparticipant(i, false)">&#10005;</span>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="input-box">
                <div class="input-label">Participants Reminder</div>
                <div class="field-dd" [class.open]="openDropdown === 'participantsReminder'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('participantsReminder')">
                        <span>{{ getParticipantsReminderLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'participantsReminder'">
                        <div class="field-dd-row" *ngFor="let item of reminder; trackBy: trackByOptionValue"
                            [class.selected]="meetDetails.participantsRemainder === item.value" (click)="selectParticipantsReminder(item.value)">
                            {{ item.viewValue }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box-full">
                <div class="input-label">Note</div>
                <textarea class="text-box" cols="30" rows="5" [(ngModel)]="meetDetails.description"></textarea>
            </div>

            <div class="input-box-full">
                <div class="input-label">Labels</div>
                <app-crm-label-picker
                    [labelIds]="selectedLabelIds"
                    [labels]="selectedLabels"
                    (labelIdsChange)="onSelectedLabelIdsChange($event)"
                    (labelsChange)="onSelectedLabelsChange($event)"
                ></app-crm-label-picker>
            </div>
        </div>

        <app-dialog-footer
            [submitLabel]="data.data.edit ? 'Update Activity' : 'Book Activity'"
            [submitDisabled]="scheduleFormInvalid"
            [loading]="createLoader"
            (cancel)="cancel()"
            (submit)="data.data.edit ? editMeet() : createMeet()">
        </app-dialog-footer>
    </section>
    <section class="main-section" *ngIf="data.data?.creationType == 'RECORD'">
        <app-dialog-header [title]="data.data.edit ? 'Edit Activity' : 'Book Activity'" (close)="cancel()"></app-dialog-header>
        <div class="input-field-section">
            <div class="input-box-full">
                <div class="input-label">Customer Name <span class="required">*</span></div>
                <input class="custom-input" placeholder="Enter customer name" [(ngModel)]="meetDetails.leadName">
            </div>
            <div class="input-box-full">
                <div class="input-label">Mobile Number <span class="required">*</span></div>
                <input class="custom-input" placeholder="Enter mobile number" [(ngModel)]="meetDetails.leadNumber">
            </div>
            <div class="input-box-full">
                <div class="input-label">Email Id</div>
                <input class="custom-input" placeholder="Enter email address" [(ngModel)]="meetDetails.leadMail">
            </div>
            <div class="input-box-full">
                <div class="input-label">Select Time</div>
                <div class="field-dd" [class.open]="openDropdown === 'startTime'" [class.disabled]="allDayCheckbox">
                    <button type="button" class="field-dd-trigger" [disabled]="allDayCheckbox" (click)="toggleDropdown('startTime')">
                        <span>{{ callStartTime || 'HH : MM' }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'startTime'">
                        <ng-container *ngFor="let item of filteredStartTimeArray">
                            <div class="field-dd-row" *ngIf="!item.isDisabled"
                                [class.selected]="callStartTime === item.viewValue" (click)="selectStartTime(item)">
                                {{ item.viewValue }}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="input-box-full" *ngIf="storeList.length > 1">
                <div class="input-label">Select Store</div>
                <div class="field-dd" [class.open]="openDropdown === 'store'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('store')">
                        <span>{{ getStoreLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'store'">
                        <div class="field-dd-row" *ngFor="let item of storeList"
                            [class.selected]="meetDetails.storeId === item.id" (click)="selectStore(item)">
                            {{ item.storeName }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-box-full" *ngIf="storeList.length === 1">
                <div class="input-label">Store</div>
                <div class="store-select-display">{{storeList[0].storeName}}</div>
            </div>
            <div class="input-box-full">
                <div class="input-label">Birthday</div>
                <div class="field-dd" [class.open]="openDropdown === 'birthday'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('birthday')">
                        <span>{{ meetDetails.birthday ? (meetDetails.birthday | date:'d MMM y') : 'DD/MM/YYYY' }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <app-custom-calendar *ngIf="openDropdown === 'birthday'" mode="single" [showTime]="false"
                        align="left" [selectedDate]="meetDetails.birthday || null"
                        (dateChange)="meetDetails.birthday = $event; closeDropdowns()" (cancel)="closeDropdowns()">
                    </app-custom-calendar>
                </div>
            </div>
            <div class="input-box-full">
                <div class="input-label">Anniversary</div>
                <div class="field-dd" [class.open]="openDropdown === 'anniversary'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('anniversary')">
                        <span>{{ meetDetails.anniversary ? (meetDetails.anniversary | date:'d MMM y') : 'DD/MM/YYYY' }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <app-custom-calendar *ngIf="openDropdown === 'anniversary'" mode="single" [showTime]="false"
                        align="left" [selectedDate]="meetDetails.anniversary || null"
                        (dateChange)="meetDetails.anniversary = $event; closeDropdowns()" (cancel)="closeDropdowns()">
                    </app-custom-calendar>
                </div>
            </div>

            <div class="input-box-full">
                <div class="input-label">Labels</div>
                <app-crm-label-picker
                    [labelIds]="selectedLabelIds"
                    [labels]="selectedLabels"
                    (labelIdsChange)="onSelectedLabelIdsChange($event)"
                    (labelsChange)="onSelectedLabelsChange($event)"
                ></app-crm-label-picker>
            </div>
        </div>

        <app-dialog-footer
            [submitLabel]="data.data.edit ? 'Update Meeting' : 'Record Activity'"
            [submitDisabled]="data.data.edit ? recordEditDisabled : recordCreateDisabled"
            [loading]="createLoader"
            (cancel)="cancel()"
            (submit)="data.data.edit ? editMeet() : recordMeeting()">
        </app-dialog-footer>
    </section>
</ng-container>


<!-- For mobile screen  -->
<ng-container *ngIf="screenWidth < 475">
    <section class="main-section" *ngIf="data.data?.creationType == null || data.data?.creationType == 'SCHEDULE'">
        <div class="header">
            <div class="header-text">{{data.data.edit ? "Edit Activity" : "Book Activity"}}</div>
            <div class="close-image" (click)="cancel()">
                <img src="../../../../../../../../assets/images/close.svg" alt="">
            </div>
        </div>
        <hr class="section-divider">
        <div class="input-field-section">
            <div class="input-box-full">
                <div class="input-label">Title <span class="required">*</span></div>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput placeholder="Enter subject" value="" [(ngModel)]="meetDetails.title">
                </mat-form-field>
            </div>
            <div class="input-box">
                <div class="input-label">Visit Type</div>
                <mat-radio-group aria-label="" [(ngModel)]="meetDetails.meetingType">
                    <div class="radio-btn-box">
                        <div class="content-box-small">
                            <mat-radio-button color="primary" value="PHYSICAL"></mat-radio-button>
                            <span>In Person</span>
                        </div>
                        <div class="content-box-small">
                            <mat-radio-button color="primary" value="VIRTUAL"></mat-radio-button>
                            <span>Virtual</span>
                        </div>
                    </div>
                </mat-radio-group>
            </div>

            <div class="input-box" *ngIf="meetDetails.meetingType === 'PHYSICAL'">
                <div class="input-label">Location Type</div>
                <mat-radio-group aria-label="" [(ngModel)]="meetDetails.locationType"
                    (ngModelChange)="changeLocationType()">
                    <div class="radio-btn-box">
                        <div class="content-box-small">
                            <mat-radio-button color="accent" value="CLIENT_LOCATION"></mat-radio-button>
                            <span>Client Location </span>
                        </div>
                        <div class="content-box-small">
                            <mat-radio-button color="accent" value="BUSINESS_LOCATION"></mat-radio-button>
                            <span>Activity</span>
                        </div>
                    </div>
                </mat-radio-group>
            </div>



            <div class="input-box" *ngIf="meetDetails.meetingType === 'VIRTUAL'">
                <div class="input-label">Meeting Provider <span class="required">*</span></div>
                <div class="radio-btn-box">
                    <div class="content-box-small" [class.disabled]="!googleIntegrationStatus?.googleMeetAvailable"
                        (click)="setMeetingLinkMode('GOOGLE_MEET')">
                        <mat-radio-button color="primary" [checked]="meetDetails.meetingLinkMode === 'GOOGLE_MEET'"
                            [disabled]="!googleIntegrationStatus?.googleMeetAvailable"></mat-radio-button>
                        <span>Google Meet</span>
                    </div>
                    <div class="content-box-small" (click)="setMeetingLinkMode('MANUAL')">
                        <mat-radio-button color="primary" [checked]="meetDetails.meetingLinkMode === 'MANUAL'"></mat-radio-button>
                        <span>Manual Link</span>
                    </div>
                    <div class="content-box-small disabled">
                        <mat-radio-button color="primary" [checked]="false" [disabled]="true"></mat-radio-button>
                        <span class="status-tag coming-soon-tag">Coming soon</span>
                        <span>Zoom</span>
                    </div>
                </div>

                <div class="hint-text" *ngIf="meetDetails.meetingLinkMode === 'GOOGLE_MEET' && googleIntegrationStatus?.reconnectRequired">
                    Google needs to be reconnected before a Google Meet link can be created. Reconnect from Settings &gt; Channels &gt; Meeting Integrations.
                </div>

                <div class="d-flex align-items-center gap-2 mt-2" *ngIf="meetDetails.meetingLinkMode === 'GOOGLE_MEET' && googleIntegrationStatus?.meetRecordingAvailable">
                    <input type="checkbox" [(ngModel)]="meetDetails.automaticRecordingEnabled">
                    <span>Automatically record this meeting</span>
                </div>

                <mat-form-field class="full-width custom-mat-form-field" appearance="outline" *ngIf="meetDetails.meetingLinkMode === 'MANUAL'">
                    <input matInput [(ngModel)]="meetDetails.meetingLink" placeholder="Enter link">

                    <div class="clipboard d-flex cursor-pointer" (click)="clipboardCopy(meetDetails.meetingLink)"
                        *ngIf="!clipboard">
                        <mat-icon style="font-size:18px;position:relative;top:3px;left:6px">file_copy</mat-icon>
                    </div>
                    <div class="clipboard" *ngIf="clipboard">
                        <img src="./../../../assets/images/common/copied_link.svg" alt="" style="width:15px" />
                    </div>
                </mat-form-field>
            </div>

            <div class="input-box input-box-meeting"
                *ngIf="meetDetails.locationType === 'CLIENT_LOCATION' && meetDetails.meetingType === 'PHYSICAL'">
                <div class="input-label">Meeting Location</div>
                <mat-form-field class="sfull-width input_card" appearance="outline">
                    <input type="text" placeholder="Search for location" matInput [formControl]="searchBox"
                        [matAutocomplete]="auto2" [(ngModel)]="meetDetails.meetingLocated" (keyup)="search()" />
                    <mat-autocomplete #auto2="matAutocomplete">
                        <mat-option *ngFor="
                            let option of searchResults | async;
                            index as i
                        " [value]="option.displayName" (click)="selectedLocations(option)">
                            {{ option.displayName | titlecase }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="input-box input-box-meeting"
                *ngIf="meetDetails.locationType == 'BUSINESS_LOCATION' && meetDetails.meetingType == 'PHYSICAL' && storeList.length  > 1">
                <div class="input-label">Select Store</div>
                <mat-form-field class="email-time custom-mat-form-field custom-mat-form-field-size"
                    appearance="outline">
                    <mat-select id="input" placeholder="Select Store" [(ngModel)]="meetDetails.storeId"
                        (selectionChange)="onStoreChange()">
                        <ng-container *ngFor="let item of storeList">
                            <mat-option [value]="item.id">{{item.storeName}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="input-box">
                <div class="start-time">
                    <div class="input-label">Start Date & Time <span class="required">*</span></div>
                    <div class="checkbox">
                        <span class="input-label">All day</span>
                        <mat-checkbox [(ngModel)]="allDayCheckbox" (click)="setStartTime()"></mat-checkbox>
                    </div>
                </div>

                <!-- <div class="email-remainder">
                    <mat-form-field class="email-date custom-mat-form-field-datepicker" appearance="outline">
                        <input matInput [matDatepicker]="enddatepicker" placeholder="DD/MM/YYYY"
                            [(ngModel)]="meetDetails.startDateTime" [min]="minDate" (dateChange)="onStartDateChange()">
                        <mat-datepicker-toggle matIconSuffix [for]="enddatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #enddatepicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="email-time custom-mat-form-field-datepicker" appearance="outline">
                        <mat-select placeholder="HH : MM" [(ngModel)]="callStartTime" [disabled]="allDayCheckbox">
                            <ng-container *ngFor="let item of filteredTimeArray">
                                <mat-option [value]="item.viewValue"
                                    (click)="setStartTime()">{{item.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->
                <div class="email-remainder">
                    <mat-form-field class="email-date custom-mat-form-field custom-mat-form-field-size"
                        appearance="outline">
                        <input matInput [matDatepicker]="startDatepicker" placeholder="DD/MM/YYYY"
                            [(ngModel)]="meetDetails.startDateTime" (dateChange)="onStartDateChange()">
                        <mat-datepicker-toggle class="custom-mat-datepicker-field" matIconSuffix
                            [for]="startDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker class="custom-mat-datepicker-field" #startDatepicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="email-time custom-mat-form-field custom-mat-form-field-size"
                        appearance="outline">
                        <mat-select id="input" placeholder="HH : MM" [(ngModel)]="callStartTime"
                            [disabled]="allDayCheckbox" (selectionChange)="onStartTimeChange()">
                            <ng-container *ngFor="let item of filteredStartTimeArray">
                                <mat-option *ngIf="!item.isDisabled" [value]="item.viewValue">{{item.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="input-box">
                <div class="input-label">End Date & Time </div>
                <div class="email-remainder">
                    <mat-form-field class="email-date custom-mat-form-field custom-mat-form-field-size"
                        appearance="outline">
                        <input matInput [matDatepicker]="endDatepicker" placeholder="DD/MM/YYYY"
                            [(ngModel)]="meetDetails.endDateTime" (dateChange)="onEndDateChange()"
                            [min]="meetDetails.startDateTime" [disabled]="allDayCheckbox">
                        <mat-datepicker-toggle class="custom-mat-datepicker-field" matIconSuffix
                            [for]="endDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker class="custom-mat-datepicker-field" #endDatepicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="email-time custom-mat-form-field custom-mat-form-field-size"
                        appearance="outline">
                        <mat-select placeholder="HH : MM" [(ngModel)]="callEndTime" [disabled]="allDayCheckbox">
                            <ng-container *ngFor="let item of filteredEndTimeArray">
                                <mat-option *ngIf="!item.isDisabled" [value]="item.viewValue">{{item.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="input-box">
                <div class="input-label">Status</div>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-select placeholder="" [(ngModel)]="meetDetails.meetingStatus">
                        <ng-container *ngFor="let item of status">
                            <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="input-box">
                <div class="input-label">Reminder</div>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-select placeholder="" [(ngModel)]="meetDetails.remainder">
                        <ng-container *ngFor="let item of reminder">
                            <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="input-box">
                <div class="input-label">Participants <span class="required">*</span> </div>

                <div class="add-participant">
                    <mat-form-field class="full-width" appearance="outline">
                        <input matInput placeholder="Enter name">
                        <div class="add-participant-btn" (click)="addParticipants()">
                            + Add
                        </div>
                    </mat-form-field>
                    <div class="total-leadname">
                        <ng-container *ngFor="let items of meetDetails.participantsList ; let i=index">
                            <div class="image_section">
                                <div class="_leadName">
                                    {{items.leadName}}
                                </div>
                                <div class="image_close" (click)="closeparticipant(i, true)">
                                    <img src="../../../../../../../../assets/images/close.svg" alt="">
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let email of meetDetails.emailData ; let i=index">
                            <div class="image_section">
                                <div class="_leadName">
                                    {{ email }}
                                </div>
                                <div class="image_close" (click)="closeparticipant(i, false)">
                                    <img src="../../../../../../../../assets/images/close.svg" alt="">
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

            </div>

            <div class="input-box">
                <div class="input-label">Participants Reminder</div>
                <mat-form-field class="full-width" appearance="outline">
                    <mat-select placeholder="" [(ngModel)]="meetDetails.participantsRemainder">
                        <ng-container *ngFor="let item of reminder">
                            <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="input-box" *ngIf="data.data.type == 'ALL_MEETINGS'">
                <div class="input-label">Select <span class="required">*</span></div>
                <div class="lead-section">
                    <mat-form-field class="select" appearance="outline">
                        <mat-select placeholder="" [(ngModel)]="participantType" (ngModelChange)="getdata()">
                            <ng-container *ngFor="let item of type">
                                <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="add-email" appearance="outline">
                        <input type="text" placeholder="Search by name" matInput [(ngModel)]="selectedContact"
                            [formControl]="myControl" [matAutocomplete]="auto" (keyup)="getdata()">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option *ngFor="let option of filteredOptions | async"
                                [value]="option.personalInfo.name" (click)="contactSelected(option)">
                                {{option.personalInfo.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="input-box" *ngIf="leadIdPipelineId">
                <div class="input-label">Assign To </div>
                <mat-form-field class="custom-mat-form-field full-width" appearance="outline">
                    <mat-select placeholder="Select Staff" [(ngModel)]="meetDetails.assignedTo"
                        (ngModelChange)="changeStaff()" #staffSelect [disableOptionCentering]="true"
                        panelClass="staff-select-panel">
                        <!-- Search Box - use disabled and no value -->
                        <mat-option disabled>
                            <input matInput placeholder="Search staff" [(ngModel)]="staffSearch"
                                (click)="$event.stopPropagation()" (keyup)="filterStaff()" autocomplete="off"
                                class="custom-search-input" />
                        </mat-option>

                        <!-- Filtered Staff List -->
                        <mat-option *ngFor="let staff of pipelineBasedStaff.get(leadIdPipelineId)?.filteredStaff"
                            [value]="staff.id">
                            {{ staff.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


            </div>


            <div class="input-box-full">
                <div class="input-label">Description</div>
                <textarea class="text-box" placeholder="Add description" cols="100" rows="4"
                    [(ngModel)]="meetDetails. description"></textarea>
            </div>

            <div class="input-box-full">
                <div class="input-label">Labels</div>
                <app-crm-label-picker
                    [labelIds]="selectedLabelIds"
                    [labels]="selectedLabels"
                    (labelIdsChange)="onSelectedLabelIdsChange($event)"
                    (labelsChange)="onSelectedLabelsChange($event)"
                ></app-crm-label-picker>
            </div>
        </div>
        <!-- <hr class="section-divider"> -->
        <div class="button-container">
            <div class="cancel-btn" (click)="cancel()">
                Cancel
            </div>
            <ng-container *ngIf="!addLoader; else addLoading">
                <button class="create-btn" (click)="createMeet()"
                    [disabled]="!meetDetails.title || !meetDetails.startDateTime  || !callStartTime || (data.data.type == 'ALL_MEETINGS'? !participantType : false )"
                    *ngIf="!data.data.edit">
                    <span *ngIf="createLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
                    <span *ngIf="!createLoader"> Book Activity</span>
                </button>
                <button class="create-btn" (click)="editMeet()"
                    [disabled]="!meetDetails.title  || !meetDetails.startDateTime  || !callStartTime || (!meetDetails.participantsList.length && !meetDetails.emailData.length)"
                    *ngIf="data.data.edit">
                    <span *ngIf="createLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
                    <span *ngIf="!createLoader">Update Meeting</span>
                </button>
            </ng-container>
        </div>
    </section>
    <section class="main-section" *ngIf="data.data?.creationType == 'RECORD'">
        <div class="header">
            <div class="header-text">{{data.data.edit ? "Edit Activity" : "Book Activity"}}</div>
            <div class="close-image" (click)="cancel()">
                <img src="../../../../../../../../assets/images/close.svg" alt="">
            </div>
        </div>
        <hr class="section-divider">
        <div class="input-field-section flex-column justify-content-start">
            <div class="input-box-full">
                <div class="input-label">Customer Name <span class="required">*</span></div>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput placeholder="Enter customer name" value="" [(ngModel)]="meetDetails.leadName">
                </mat-form-field>
            </div>
            <div class="input-box-full">
                <div class="input-label">Mobile Number <span class="required">*</span></div>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput placeholder="Enter mobile number" value="" [(ngModel)]="meetDetails.leadNumber">
                </mat-form-field>
            </div>
            <div class="input-box-full">
                <div class="input-label">Email Id</div>
                <mat-form-field class="full-width" appearance="outline">
                    <input matInput placeholder="Enter email address" value="" [(ngModel)]="meetDetails.leadMail">
                </mat-form-field>
            </div>
            <div class="input-box-full">
                <div class="input-label">Select Time</div>
                <mat-form-field class="email-time custom-mat-form-field custom-mat-form-field-size" appearance="outline"
                    style="width:100%">
                    <mat-select id="input" placeholder="HH : MM" [(ngModel)]="callStartTime" [disabled]="allDayCheckbox"
                        (selectionChange)="onStartTimeChange()">
                        <ng-container *ngFor="let item of filteredStartTimeArray">
                            <mat-option *ngIf="!item.isDisabled" [value]="item.viewValue">{{item.viewValue}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="button-container">
            <div class="cancel-btn" (click)="cancel()">
                Cancel
            </div>
            <ng-container *ngIf="!addLoader; else addLoading">
                <button class="create-btn" (click)="recordMeeting()"
                    [disabled]="!meetDetails.leadName || !meetDetails.leadNumber" *ngIf="!data.data.edit">
                    <span *ngIf="createLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
                    <span *ngIf="!createLoader"> Book Activity</span>
                </button>
                <button class="create-btn" (click)="editMeet()"
                    [disabled]="!meetDetails.title  || !meetDetails.startDateTime  || !callStartTime || (!meetDetails.participantsList.length && !meetDetails.emailData.length)"
                    *ngIf="data.data.edit">
                    <span *ngIf="createLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
                    <span *ngIf="!createLoader">Update Meeting</span>
                </button>
            </ng-container>
        </div>
    </section>
</ng-container>


<ng-template #addLoading>
    <button class="continue">
        <i class="fa fa-spinner fa-spin"></i> &nbsp;Loading
    </button>
</ng-template>